import DiscountInput from './DiscountInput';
import { connect } from 'react-redux';
import { setManagerDiscount } from '../../stateManagement/engine/actions/OrderActions';

function mapStateToProps(state) {
  return {
    currency: state.session.organization.currency,
    locale: state.session.organization.locale,
    value: state.order.managerDiscount.amount,
    unit: state.order.managerDiscount.unit,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onChange: amount => dispatch(setManagerDiscount({ amount })),
    onUnitChange: unit => dispatch(setManagerDiscount({ unit })),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DiscountInput);
